module.exports = __webpack_public_path__ + "static/media/photo-1.1369f5f9.webp";